<template>
  <v-row class="defaultLogin-form center-x">
    <v-col class="center-x" xs="12" md="6" lg="6" xl="6">
      <v-card max-width="80%" :loading="isCheckLogin">
        <h1 class="center-x">Login</h1>
        <div>
          <v-form
            ref="signin"
            method="post"
            id="form-signin"
            novalidate="true"
            @submit.prevent="submitCheckFormLogin"
          >
            <v-row justify="center">
              <v-col cols="10">
                <v-text-field
                  v-model="form.email"
                  required
                  outlined
                  color="secondary"
                  label="E-mail"
                  :rules="rules.email"
                  hint="Preencha seu E-mail!"
                />
              </v-col>
              <v-col cols="10">
                <v-text-field
                  v-model="form.password"
                  required
                  outlined
                  color="secondary"
                  label="Password"
                  :rules="rules.other"
                  hint="Mínimo 6 letras!"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                />
                <v-btn
                  class="anchor"
                  text
                  small
                  rounded
                  @click.prevent="() => alert('Em desenvolvimento')"
                  >Recuperar Senha!</v-btn
                >
              </v-col>
              <v-col cols="10" class="center-x">
                <v-btn
                  rounded
                  height="48"
                  width="50%"
                  elevation="6"
                  type="submit"
                  color="primary"
                  form="form-signin"
                  :disabled="isValidForm"
                  :loading="isCheckLogin"
                  >Login</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "defaultLogin-form",
  data: () => ({
    errors: [],
    showPassword: false,
    isCheckLogin: false,
    form: {
      email: null,
      password: null
    },
    regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    rules: {
      email: [
        value => !!value || "E-mail é obrigatório!",
        value =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            value
          ) || "E-mail deve ser válido!"
      ],
      other: [
        value => !!value || "Campo obrigatório!",
        value => value.length >= 6 || "No mínimo 6 caracteres"
      ]
    }
  }),
  computed: {
    isValidForm() {
      return (this.form.email && this.form.password) == "" ? true : false;
    }
  },
  methods: {
    ...mapActions({
      actionLogin: "auth/actionLogin",
      actionGetUser: "auth/actionGetUser"
    }),

    submitCheckFormLogin() {
      this.errors = [];

      if (!this.form.email) this.errors.push("Campo obrigatório!");
      else if (!this.validateEmail(this.form.email))
        this.errors.push("E-mail inválido!");

      if (!this.form.password) this.errors.push("Campo obrigatório!");
      else if (this.form.password.length < 6)
        this.errors.push("No mínimo 6 caracteres!");

      if (!this.errors.length) {
        this.isCheckLogin = !this.isCheckLogin;
        this.actionLogin({
          email: this.form.email,
          password: this.form.password
        })
          .then(() => {
            this.clear();
            this.isCheckLogin = !this.isCheckLogin;
            this.$router.push("monitoramento");
          })
          .catch(() => {
            this.isCheckLogin = !this.isCheckLogin;
          });
        return true;
      }
    },
    validateEmail(email) {
      /** Aplicando Regex no e-mail passado! */
      return this.regex.test(email);
    },
    clear() {
      this.form.email = "";
      this.form.password = "";
    }
  }
};
</script>
